import { useColorModeValue } from "@chakra-ui/react";
import { TextProps } from "@chakra-ui/layout/dist/types/text";

import { useGetThemeColors } from "ChakraTheme";

import { ChakraText } from "../ChakraText";

interface IProps extends Omit<TextProps, "color" | "c"> {}

const RedText = ({ children, ...props }: IProps) => {
  const colors = useGetThemeColors();
  const color = useColorModeValue(colors.red[600], colors.red[400]);

  return (
    <ChakraText color={color} {...props}>
      {children}
    </ChakraText>
  );
};

export { RedText };
